export function BrandLogo({
  className = "h-8 w-auto",
}: {
  className?: string;
}) {
  return (
    <img
      src="/acid-logo.png"
      alt="ACID"
      width={146}
      height={46}
      className={className}
      decoding="async"
    />
  );
}
